import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import { useState, useEffect } from "react";
import { parse as _parse, stringify as _stringify } from "query-string";
import numeral from "numeral";
export var lowercaseAndParseSpaces = function lowercaseAndParseSpaces(a, b) {
  return a.toLowerCase().split(" ").join(b || "_");
};
var defaultOptions = {
  arrayFormat: "comma",
  parseNumbers: !0
};
export var qs = {
  parse: function parse(a, b) {
    var c = _parse(a, _objectSpread({}, b || {}, {}, defaultOptions));

    return c;
  },
  stringify: function stringify(a, b) {
    return _stringify(a, _objectSpread({}, b || {}, {}, defaultOptions));
  }
};
export var range = {
  parse: function parse(a) {
    if (a) {
      a = a.toString();
      var b = a.split("-");
      if (b.length) return b.map(function (a) {
        return a ? parseFloat(a) : a;
      });
    }

    return a;
  },
  stringify: function stringify(a) {
    return a && 1 < a.length ? a.join("-") : a;
  }
};
export var arrayToInt = {
  parse: function parse(a) {
    return Array.isArray(a) ? a.map(function (a) {
      return a ? parseInt(a) : a;
    }) : a;
  }
};
export var formatPrice = function formatPrice(a, b) {
  var c = b || {},
      d = c.million,
      e = void 0 === d ? "($0.00a)" : d,
      f = c.other,
      g = void 0 === f ? "($0,00)" : f,
      h = c.noPrice,
      i = void 0 === h ? "Contact Agent" : h,
      j = 1e6 <= a ? e : g;
  return a ? numeral(a).format(j) : a || i;
};
export var useInfiniteScroll = function useInfiniteScroll(a, b) {
  // eslint-disable-line
  function c() {
    var a = document.documentElement.offsetHeight - d,
        b = window.innerHeight,
        c = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    g || b + c < a || h(!0);
  }

  var d = b.offset || 0,
      e = useState(!1),
      f = _slicedToArray(e, 2),
      g = f[0],
      h = f[1];

  return useEffect(function () {
    g && a();
  }, [g]), useEffect(function () {
    return window.addEventListener("scroll", c), function () {
      return window.removeEventListener("scroll", c);
    };
  }, []), [g, h];
};